var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRexmdlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 267 88",
    style: {
      enableBackground: "new 0 0 267 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#151C30;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#B32025;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,42.6l15.6,20.7h-7.1l-12.2-16.5l-12.2,16.5h-6.9l15.6-20.7l-15-20h7l11.6,15.7l11.6-15.7h7L116.4,42.6 L116.4,42.6z M56.8,40.3h29.8v5.5H56.8V40.3L56.8,40.3z M56.8,57.9h29.8v5.5H56.8V57.9L56.8,57.9z M56.8,22.6h29.8v5.5H56.8V22.6 L56.8,22.6z M35.8,47.1l12.2,16.3h-7.2L29.4,48.1H19.3v15.3h-5.9V22.6H31c4.2,0,8.6,1.1,11.7,4.1c2.2,2.2,3.2,5.2,3.2,8.2v0.1 C45.9,41.6,41.7,45.6,35.8,47.1L35.8,47.1z M19.3,42.7h11.3c4.6,0,9.4-2.1,9.4-7.4v-0.1c0-5.3-4.7-7-9.3-7H19.3V42.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.7,9h101.1c3.1,0,5.7,2.6,5.7,5.7v56.6c0,3.1-2.6,5.7-5.7,5.7H150.7c-3.1,0-5.7-2.6-5.7-5.7V14.7 C145.1,11.6,147.6,9,150.7,9L150.7,9z M209.1,63.4h14.3c11.9,0,21.6-8.1,21.6-20.4v-0.1c0-12.2-9.7-20.2-21.6-20.2h-14.3V63.4 L209.1,63.4z M177.1,43.5l-13.9-20.9h-5.6v40.7h5.8V33.2l13.2,19.4h1l13.2-19.4v30.2h5.9V22.6H191L177.1,43.5L177.1,43.5z M215,28.2 v29.6h8.5c8.8,0,15.6-5.7,15.6-14.7V43c0-9-6.7-14.8-15.6-14.8H215z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRexmdlogo);
export default __webpack_public_path__ + "static/media/rexmdlogo.cf27dbfe524a391c395a61e83f091b64.svg";
export { ForwardRef as ReactComponent };